export default class OneDimensionStrategy {
  constructor (dimension, filter) {
    this.dimension = dimension
    this.filter = filter
    this.storeFilters = {}
    this.productFilters = {}
  }

  _buildDimensions () {
    const selectedDimensionIds = [this.dimension.id]
    if (this.dimension.type === 'store') this.storeDimensions = selectedDimensionIds
    if (this.dimension.type === 'product') this.productDimensions = selectedDimensionIds
  }

  _buildFilter () {
    const filterIds = this.filter.value
    if (this.filter.keyFieldType === 'store') this.storeFilters[this.filter.keyField] = filterIds
    if (this.filter.keyFieldType === 'product') this.productFilters[this.filter.keyField] = filterIds
  }

  build () {
    if (!('dimension' in this)) {
      throw new Error('Falta la dimensión')
    }
    if (this.filter) {
      this._buildFilter()
    }
    this._buildDimensions()
    return this
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/OneDimensionStrategy.js